import { useTranslation } from 'react-i18next';

import {
  ProjectPropertiesMenuItem,
  ProjectPropertiesMenuItemPrefix,
  ProjectPropertiesMenuItemValue,
} from '@/features/projects/project-details/components/layouts/project-properties-menu-layout';

export const SubcategoryItem = ({ subCategory }: { subCategory: string }) => {
  const { t } = useTranslation('project', { keyPrefix: 'Shared' });
  const { t: categoryT } = useTranslation('categories', {
    keyPrefix: 'Level3',
  });

  return (
    <ProjectPropertiesMenuItem>
      <ProjectPropertiesMenuItemPrefix>
        {t('subcategory')}
      </ProjectPropertiesMenuItemPrefix>
      <ProjectPropertiesMenuItemValue>
        {categoryT(subCategory as any)}
      </ProjectPropertiesMenuItemValue>
    </ProjectPropertiesMenuItem>
  );
};
